const general = {
    placeholder: 'Espaço reservado',
    submit: 'Enviar',
    skip: 'Pular',
    next: 'Próximo',
    back: 'Voltar',
    retry: 'Tentar novamente',
    done: 'Feito',
    search: 'Buscar',
    search_placeholder: 'Buscar',
    clear_result: 'Limpar resultados',
    save: 'Salvar',
    save_changes: 'Salvar alterações',
    saved: 'Salvo',
    discard: 'Descartar',
    /** UNTRANSLATED */
    download: 'Download',
    loading: 'Carregando...',
    redirecting: 'Redirecionando...',
    add: 'Adicionar',
    added: 'Adicionado',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    check_out: 'Finalizar compra',
    create: 'Criar',
    set_up: 'Configurar',
    customize: 'Personalizar',
    enable: 'Habilitar',
    reminder: 'Lembrete',
    edit: 'Editar',
    delete: 'Excluir',
    deleted: 'Excluído',
    more_options: 'MAIS OPÇÕES',
    close: 'Fechar',
    copy: 'Copiar',
    copying: 'Copiando',
    copied: 'Copiado',
    required: 'Obrigatório',
    add_another: 'Adicionar outro',
    create_another: 'Criar outro',
    deletion_confirmation: 'Tem certeza de que deseja excluir este {{title}}?',
    settings_nav: 'Configurações',
    unsaved_changes_warning: 'Você fez algumas alterações. Tem certeza de que deseja sair desta página?',
    leave_page: 'Sair da página',
    stay_on_page: 'Permanecer na página',
    type_to_search: 'Digite para pesquisar',
    got_it: 'Entendi',
    continue: 'Continuar',
    page_info: '{{min, number}}-{{max, number}} de {{total, number}}',
    learn_more: 'Saiba mais',
    tab_error_one: '{{count, number}} erro',
    tab_error_other: '{{count, number}} erros',
    skip_for_now: 'Pular por agora',
    remove: 'Remover',
    visit: 'Visitar',
    join: 'Entrar',
    try_now: 'Experimentar agora',
    multiple_form_field: '(Múltiplo)',
    demo: 'Demo',
    unnamed: 'Sem nome',
    view: 'Ver',
    open: 'Abrir',
    hide: 'Ocultar',
    unknown_error: 'Erro desconhecido, por favor tente novamente mais tarde.',
    select: 'Selecionar',
    contact_us_action: 'Contate-nos',
    description: 'Descrição',
    name: 'Nome',
    add_field: 'Adicionar {{field}}',
    create_field: 'Criar {{field}}',
    edit_field: 'Editar {{field}}',
    delete_field: 'Excluir {{field}}',
    coming_soon: 'Em breve',
    or: 'Ou',
    reset: 'Redefinir',
    generate: 'Gerar',
};
export default Object.freeze(general);
